// Base URL for cookie-session calls. The storefront store sets this when it loads.
// Tests leave it empty so resume checks keep using the stored bearer token.
let sessionApi = ''

export function configureSessionApi(api) {
	sessionApi = api || ''
}

export function getSessionApi() {
	return sessionApi
}
